import Vue from 'vue'


// CustomSearchSelectInput
Vue.component('custom-search-select-input', (resolve) => {
  import('./Components/Views/Demo/CustomSearchSelectInput').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});

Vue.component('dashboard-default', (resolve) => {
  import('./Components/Views/Demo/Dashboard/Default').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});
Vue.component('dashboard-services', (resolve) => {
  import('./Components/Views/Demo/Dashboard/Services').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});
Vue.component('dashboard-academy', (resolve) => {
  import('./Components/Views/Demo/Dashboard/Academy').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});
Vue.component('dashboard-ecommerce', (resolve) => {
  import('./Components/Views/Demo/Dashboard/ECommerce').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});
Vue.component('dashboard-hospital', (resolve) => {
  import('./Components/Views/Demo/Dashboard/Hospital').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});
Vue.component('dashboard-hrm', (resolve) => {
  import('./Components/Views/Demo/Dashboard/HRM').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});


// Forms
Vue.component('form-layouts', (resolve) => {
  import('./Components/Views/Demo/Form/form-layouts/FormLayouts').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});
Vue.component('form-grid', (resolve) => {
  import('./Components/Views/Demo/Form/form-layouts/components/FormGrid').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});
Vue.component('form-row', (resolve) => {
  import('./Components/Views/Demo/Form/form-layouts/components/FormRow').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});
Vue.component('form-horizontal', (resolve) => {
  import('./Components/Views/Demo/Form/form-layouts/components/HorizontalForm').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});
Vue.component('form-validation', (resolve) => {
  import('./Components/Views/Demo/Form/form-validation/FormValidationIndex').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});
Vue.component('form-validation-required', (resolve) => {
  import('./Components/Views/Demo/Form/form-validation/component/FormValidationRequired').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});
Vue.component('form-validation-range', (resolve) => {
  import('./Components/Views/Demo/Form/form-validation/component/FormRangeValidation').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});
Vue.component('input-text', (resolve) => {
  import('./Components/Views/Demo/Form/InputText').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});


// All input forms
Vue.component('all-form-inputs', (resolve) => {
  import('./Components/Views/Demo/Form/form-elements/FormElements').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});
Vue.component('form-input-fields', (resolve) => {
  import('./Components/Views/Demo/Form/form-elements/components/FormInput').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});
Vue.component('form-date-time-fields', (resolve) => {
  import('./Components/Views/Demo/Form/form-elements/components/FormDateTimePIcker').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});
Vue.component('form-multi-select-fields', (resolve) => {
  import('./Components/Views/Demo/Form/form-elements/components/FormMultiSelect').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});
Vue.component('form-radio-fields', (resolve) => {
  import('./Components/Views/Demo/Form/form-elements/components/FormRadio').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});
Vue.component('form-files-fields', (resolve) => {
  import('./Components/Views/Demo/Form/form-elements/components/FormFiles').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});
Vue.component('multiple-form-files-fields', (resolve) => {
  import('./Components/Views/Demo/Form/form-elements/components/FormMultipleFiles').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});

// Tables
Vue.component('basic-datatable', (resolve) => {
  import('./Components/Views/Demo/Tables/basic-datatable/Index').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});
Vue.component('advance-datatable', (resolve) => {
  import('./Components/Views/Demo/Tables/AdvanceDatatable').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});
Vue.component('responsive-datatable', (resolve) => {
  import('./Components/Views/Demo/Tables/ResponsiveDatatable').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});
Vue.component('datatable-with-filter', (resolve) => {
  import('./Components/Views/Demo/Tables/filter-type-datatable/Index').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});
Vue.component('datatable-pagination', (resolve) => {
  import('./Components/Views/Demo/Tables/datatable-pagination/Index').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});
Vue.component('grid-view-table', (resolve) => {
  import('./Components/Views/Demo/Tables/grid-view/Index').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});
Vue.component('grid-view', (resolve) => {
  import('./Components/Views/Demo/Tables/grid-view/GridView').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});
Vue.component('profile-card', (resolve) => {
  import('./Components/Views/Demo/Tables/grid-view/ProfileCard').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});


// UI Features
Vue.component('icons', (resolve) => {
  import('./Components/Views/Demo/UI/icons/Index').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});
Vue.component('app-modals', (resolve) => {
  import('./Components/Views/Demo/UI/modals/Modals').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});
Vue.component('buttons', (resolve) => {
  import('./Components/Views/Demo/UI/buttons/Buttons').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});
Vue.component('avatars', (resolve) => {
  import('./Components/Views/Demo/UI/avatars/Avatars').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});
Vue.component('badges', (resolve) => {
  import('./Components/Views/Demo/UI/badges/Badges').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});
Vue.component('error-notes', (resolve) => {
  import('./Components/Views/Demo/UI/error-notes/ErrorNotes').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});
Vue.component('checkboxes-radios', (resolve) => {
  import('./Components/Views/Demo/UI/checkboxes-radios/CheckboxesRadios').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});
Vue.component('cards', (resolve) => {
  import('./Components/Views/Demo/UI/cards/Cards').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});
Vue.component('tabs', (resolve) => {
  import('./Components/Views/Demo/UI/tabs/Tabs').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});
Vue.component('tab-setting', (resolve) => {
  import('./Components/Views/Demo/UI/tabs/components/TabSetting').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});
Vue.component('inner-tab', (resolve) => {
  import('./Components/Views/Demo/UI/tabs/components/InnerTab').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});
Vue.component('tab-inside-tab', (resolve) => {
  import('./Components/Views/Demo/UI/tabs/components/InnerComponent').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});
Vue.component('nothing-to-show', (resolve) => {
  import('./Components/Views/Demo/UI/nothing-to-show/NothingToShow').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});
Vue.component('form-wizard', (resolve) => {
  import('./Components/Views/Demo/Form/form-wizard/FormWizard').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});
Vue.component('form-wizard-basic-info', (resolve) => {
  import('./Components/Views/Demo/Form/form-wizard/BasicInfo').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});
Vue.component('form-wizard-contact-info', (resolve) => {
  import('./Components/Views/Demo/Form/form-wizard/ContactInfo').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});
Vue.component('form-wizard-others', (resolve) => {
  import('./Components/Views/Demo/Form/form-wizard/Others').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});

// Sample Pages
Vue.component('chat', (resolve) => {
  import('./Components/Views/Demo/Pages/chat/Index').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});
Vue.component('blank-page', (resolve) => {
  import('./Components/Views/Demo/Pages/Blank').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});
Vue.component('calendar-view', (resolve) => {
  import('./Components/Views/Demo/Pages/calendar-view/CalendarView').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});
Vue.component('event-add-edit-modal', (resolve) => {
  import('./Components/Views/Demo/Pages/calendar-view/EventAddEditModal').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});
Vue.component('report', (resolve) => {
  import('./Components/Views/Demo/Pages/Report').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});
Vue.component('kanban-view', (resolve) => {
  import('./Components/Views/Demo/Pages/kanban-view/KanbanView').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});
Vue.component('task-add-edit-modal', (resolve) => {
  import('./Components/Views/Demo/Pages/kanban-view/TaskAddEditModal').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});


// Demo Crud
Vue.component('app-demo-crud', (resolve) => {
  import('./Components/Views/Demo/Tables/demo-crud/Index').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});
Vue.component('app-add-modal', (resolve) => {
  import('./Components/Views/Demo/Tables/demo-crud/AddModal').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});
Vue.component('btn-add-modal', (resolve) => {
  import('./Components/Views/Demo/Tables/demo-crud/buttonModal').then((AsyncComponent) => {
      resolve(AsyncComponent.default);
    })});
